/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Font_Size_LabelInputs */

const en_styles_font_size_label = /** @type {(inputs: Styles_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Font Size`)
};

const fr_styles_font_size_label = /** @type {(inputs: Styles_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille de police`)
};

const de_styles_font_size_label = /** @type {(inputs: Styles_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schriftgröße`)
};

const it_styles_font_size_label = /** @type {(inputs: Styles_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensione del carattere`)
};

const ru_styles_font_size_label = /** @type {(inputs: Styles_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Размер шрифта`)
};

const es_styles_font_size_label = /** @type {(inputs: Styles_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño de fuente`)
};

const zh_cn2_styles_font_size_label = /** @type {(inputs: Styles_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字体大小`)
};

const ja_styles_font_size_label = /** @type {(inputs: Styles_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォントサイズ`)
};

const hi_styles_font_size_label = /** @type {(inputs: Styles_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ॉन्ट आकार`)
};

const pt_pt2_styles_font_size_label = /** @type {(inputs: Styles_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho da fonte`)
};

/**
* | output |
* | --- |
* | "Font Size" |
*
* @param {Styles_Font_Size_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_font_size_label = /** @type {((inputs?: Styles_Font_Size_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Font_Size_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_font_size_label(inputs)
	if (locale === "de") return de_styles_font_size_label(inputs)
	if (locale === "it") return it_styles_font_size_label(inputs)
	if (locale === "ru") return ru_styles_font_size_label(inputs)
	if (locale === "es") return es_styles_font_size_label(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_font_size_label(inputs)
	if (locale === "ja") return ja_styles_font_size_label(inputs)
	if (locale === "hi") return hi_styles_font_size_label(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_font_size_label(inputs)
	return en_styles_font_size_label(inputs)
});